import React, { useRef } from 'react';

import LnbComponent from './LnbComponent';
import FooterLayoutComponent from '../common/layout/FooterLayoutComponent';
import { Link } from 'react-router-dom';

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop);

const ProductionComponent = props => {
    const { selectedProductionIdx, onClickBtnProduction } = props;

    const infraRef = useRef(null);
    const fabricRef = useRef(null);
    const garmentRef = useRef(null);

    const executeScroll = (ref) => scrollToRef(ref);

    return (
        <main className="about">
            <div className="body">
                <div className="head">
                    <div className="title">
                        PRODUCTION
                </div>
                    <LnbComponent
                        tabIdx={2}
                        {...props}
                    />
                </div>
                <section className="production-1">
                    <h3>Sustainable Production Process</h3>
                    <div className="desc">
                        <p>
                            From the beginning to the end of the denim
                            production process, advanced eco-friendly
                            equipment and systems are the result of TCE
                            technology that goes beyond simple denim
                            production.
                                </p>
                    </div>
                    <div className="image-list">
                        <div className="item" onClick={evt => executeScroll(infraRef)}>
                            <div className="img" >
                                <img
                                    src="/imgs/aboutTCE_Production_1.png"
                                    alt="Infrastructures & Facilities"
                                />
                                <div class='text'>Infrastructures &<br />Facilities</div>
                            </div>
                            <div class='controller mb'>
                                <button class='btn btn-more'
                                    onClick={evt => onClickBtnProduction(evt, 2)}>VIEW MORE</button>
                            </div>
                        </div>
                        <div className="item" onClick={evt => executeScroll(fabricRef)}>
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_Production_2.png"
                                    alt="Fabric Production"
                                />
                                <div class='text'>Fabric<br />Production</div>
                            </div>
                            <div class='controller mb'>
                                <button class='btn btn-more'
                                    onClick={evt => onClickBtnProduction(evt, 3)}>VIEW MORE</button>
                            </div>
                        </div>
                        <div className="item" onClick={evt => executeScroll(garmentRef)}>
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_Production_3.png"
                                    alt="Garment Production"
                                />
                                <div class='text'>Garment<br />Production</div>
                            </div>
                            <div class='controller mb'>
                                <button class='btn btn-more'
                                    onClick={evt => onClickBtnProduction(evt, 4)}>VIEW MORE</button>
                            </div>
                        </div>
                    </div>
                </section>
                <section ref={infraRef} className={`production-2 ${selectedProductionIdx === 2 ? "on" : ""}`}>
                    <button class="mb btn-close-modal black"
                        onClick={evt => onClickBtnProduction(evt, 1)}><i></i></button>
                    <h2>Infrastructures & Facilities</h2>
                    <div className="item t1">
                        <div className="info">
                            <div className="title">
                                <div className="no">01.</div>
                                <div className="text">
                                    WASTE-WATER RECYCLE SYSTEM
                                        </div>
                            </div>
                            <div className="desc">
                                <p>
                                    Maximum 657,000 tons of
                                    wastewater/year is recycled back
                                    into the production process after
                                    being treated using a reverse
                                    osmosis system. (Based on drinking
                                    water standard)
                                        </p>
                            </div>
                        </div>
                        <div className="image-list">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_Production_4.png"
                                    alt="WASTE-WATER RECYCLE SYSTEM"
                                />
                            </div>
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_Production_5.png"
                                    alt="WASTE-WATER RECYCLE SYSTEM"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="item t2">
                        <div className="info">
                            <div className="title">
                                <div className="no">02.</div>
                                <div className="text">
                                    OZONE WASTEWATER RECYCLING SYSTEM
                                        </div>
                            </div>
                            <div className="desc">
                                <p>
                                    Recycle max.15,000 liters/hour of
                                    water after washing
                                        </p>
                            </div>
                        </div>
                        <div className="img">
                            <img
                                src="/imgs/aboutTCE_Production_6.png"
                                alt="OZONE WASTEWATER RECYCLING SYSTEM"
                            />
                        </div>
                    </div>

                    <div className="item t2">
                        <div className="info">
                            <div className="title">
                                <div className="no">03.</div>
                                <div className="text">
                                    Steam Drain Water Reusing System
                                        </div>
                            </div>
                            <div className="desc">
                                <p>
                                    Our reusing system collects steam
                                    used in production and condenses it,
                                    then takes the high-temperature
                                    water and vaporizes it for reuse.
                                        </p>
                            </div>
                        </div>
                        <div className="img">
                            <img
                                src="/imgs/aboutTCE_Production_7.png"
                                alt="Steam Drain Water Reusing System"
                            />
                        </div>
                    </div>

                    <div className="item t2">
                        <div className="info">
                            <div className="title">
                                <div className="no">04.</div>
                                <div className="text">
                                    Cooling Water Reusing System
                                        </div>
                            </div>
                            <div className="desc">
                                <p>
                                    Cooling water is used to cool the
                                            cylinder<br />
                                            of the production machine. Then the
                                            water, which has only slightly
                                            increased in temperature, is
                                            collected, and reused back into the
                                            production process.
                                        </p>
                            </div>
                        </div>
                        <div className="img">
                            <img
                                src="/imgs/aboutTCE_Production_8.png"
                                alt="Steam Drain Water Reusing System"
                            />
                        </div>
                    </div>

                    <div className="item t2">
                        <div className="info">
                            <div className="title">
                                <div className="no">05.</div>
                                <div className="text">
                                    SOLAR ENERGY
                                        </div>
                            </div>
                            <div className="desc">
                                <p>
                                    We have adopted a solar energy
                                    generation facility in our mills to
                                    reduce the total amount of energy
                                    used in production.
                                        </p>
                            </div>
                        </div>
                        <div className="img">
                            <img
                                src="/imgs/aboutTCE_Production_9.png"
                                alt="Steam Drain Water Reusing System"
                            />
                        </div>
                    </div>
                </section>
                <section ref={fabricRef} className={`production-3 ${selectedProductionIdx === 3 ? "on" : ""}`}>
                    <button class="mb btn-close-modal black"
                        onClick={evt => onClickBtnProduction(evt, 1)}><i></i></button>
                    <h2>Fabric Production</h2>
                    <div className="item t1">
                        <div className="image">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_Production_10.png"
                                    alt="Less Water Dyeing"
                                />
                            </div>
                            <div className="no">01.</div>
                        </div>
                        <div className="info">
                            <div className="title">
                                Less Water Dyeing
                                    </div>
                            <div className="desc">
                                <p>
                                    We are introducing Less Water Dyeing
                                    which uses eco-friendly dye
                                    chemicals that reduce the amount of
                                    water used.
                                        </p>
                            </div>
                        </div>
                    </div>
                    <div className="item t2">
                        <div className="info">
                            <div className="title">
                                One Bath Sulphur Dyeing
                                    </div>
                            <div className="desc">
                                <p>
                                    New dyeing technology only requires
                                    1 bath, using new Pad-Ox sulfur
                                    dyeing method, which saves water and
                                    chemicals.
                                        </p>
                            </div>
                        </div>
                        <div className="image">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_Production_11.png"
                                    alt="One Bath Sulphur Dyeing"
                                />
                            </div>
                            <div className="no">02.</div>
                        </div>
                    </div>
                    <div className="item t1">
                        <div className="image">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_Production_12.png"
                                    alt="Eco-Friendly Sanforizing Finishing
                                        Machine"
                                />
                            </div>
                            <div className="no">03.</div>
                        </div>
                        <div className="info">
                            <div className="title">
                                Eco-Friendly Sanforizing Finishing
                                Machine
                                    </div>
                            <div className="desc">
                                <p>
                                    By running the Eco-friendly
                                    Sanforizing Denim Production Line,
                                    we are constantly reducing energy,
                                    water, and greenhouse gas emissions
                                    from our production processes.
                                        </p>
                            </div>
                        </div>
                    </div>
                    <div className="item t3">
                        <div className="info">
                            <div className="title">
                                Aniline Free<br />
                                        Indigo Dyeing
                                    </div>
                            <div className="desc">
                                <p>
                                    We strive to produce sustainable
                                    authentic denim without aniline. The
                                    DENISOL® PURE INDIGO 30 liq has been
                                    used in order to Aniline Free Indigo
                                    Dyeing.
                                        </p>
                            </div>
                        </div>
                        <div className="image t2">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_Production_13.png"
                                    alt="Aniline Free Indigo Dyeing"
                                />
                                <div className="text">
                                    #AnilineFreeDenim
                                        </div>
                            </div>
                            <div className="no">04.</div>
                        </div>
                    </div>
                </section>
                <section ref={garmentRef} className={`production-4 ${selectedProductionIdx === 4 ? "on" : ""}`}>
                    <button class="mb btn-close-modal black"
                        onClick={evt => onClickBtnProduction(evt, 1)}><i></i></button>
                    <h2>Garment Production</h2>
                    <div className="desc">
                        <p>
                            It’s believed that denim requires the use of
                            a large amount of water and chemicals to
                            process. TCE is developing sustainable
                            technologies that change these stereotypes.
                                </p>
                    </div>
                    <div className="reduce">
                        <h3>REDUCED</h3>
                        <div className="divider"></div>
                        <div className="item-list">
                            <div className="item water">
                                <div className="name">WATER</div>
                                <div className="img">
                                    <div className="text">
                                        15.3<span>%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="item steam">
                                <div className="name">STEAM</div>
                                <div className="img">
                                    <div className="text">
                                        52.2<span>%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="item chemical">
                                <div className="name">CHEMICAL</div>
                                <div className="img">
                                    <div className="text">
                                        40.5<span>%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="machine">
                        <h3>THROUGHT THE FOLLOWING MACHINES</h3>
                        <div className="divider"></div>
                        <h4>WET PROCESS</h4>
                        <div className="item-list">
                            <div className="item item-1">
                                <div className="info">
                                    <div className="title">
                                        Micro bubble washing machine
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · Considerable number of
                                            finishing effects with the
                                                    highest quality <br />
                                                    · Minimal amount of water
                                                    and zero discharge <br />
                                                    · Shorten the process in
                                                    time and steps
                                                </p>
                                    </div>
                                    <div className="arrow">
                                        <i className='arrow-right'></i>
                                    </div>
                                </div>
                                <div className="img">
                                    <img
                                        src="/imgs/aboutTCE_Production_17.png"
                                        alt="Micro Bubble Washing machine"
                                    />
                                </div>
                            </div>

                            <div className="item item-2">
                                <div className="img">
                                    <img
                                        src="/imgs/aboutTCE_Production_18.png"
                                        alt="Front loading less water washing machine"
                                    />
                                </div>
                                <div className="info">
                                    <div className="title">
                                        Front loading less water washing
                                        machine
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · Reduce the usage of water,
                                            steam, chemical, and
                                                    energy<br />
                                                    · Shorter process time
                                                    <br />
                                                    · Increase the efficiency
                                                </p>
                                    </div>
                                    <div className="arrow">
                                        <i className='arrow-left'></i>
                                    </div>
                                </div>
                            </div>

                            <div className="item item-3d">
                                <div className="info">
                                    <div className="title">
                                        Ozone washing machine
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · Water and energy
                                                    reductions<br />
                                                    · Eliminate the need for
                                                    toxic chemicals<br />
                                                    · Less reprocessing
                                                </p>
                                    </div>
                                    <div className="arrow">
                                        <i className='arrow-right'></i>
                                    </div>
                                </div>
                                <div className="img">
                                    <img
                                        src="/imgs/aboutTCE_Production_19.png"
                                        alt="Ozone washing machine"
                                    />
                                </div>
                            </div>

                            <div className="item item-4">
                                <div className="info">
                                    <div className="title">
                                        Energy saving fast dry machine
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · Less chemicals such as
                                            detergents, dispersive
                                            agents or
                                                    anti-backstaining<br />
                                                    · Less or No ozone <br />
                                                    · Recirculates hot air as
                                                    much as possible <br />
                                                    · No lose or minimum loss of
                                                    efficiency with the passing
                                                    of time
                                                </p>
                                    </div>
                                </div>
                                <div className="info">
                                    <div className="title">
                                        Chemical Dispensing System
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · The zero-fault amount of
                                                    chemicals <br />
                                                    · Improving the product
                                                    quality and quality control
                                                    <br />
                                                    · Safe for workers because
                                                    no humans put harmful
                                                    chemicals
                                                </p>
                                    </div>
                                </div>
                            </div>
                            <div className="item item-4">
                                <div className="info">
                                    <div className="title">
                                        High speed & automatic hydro
                                        extractor
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · Achieve energy savings for
                                            drying up to 400 Kcal./kg.
                                                    of dry garments<br />
                                                    · Great efficiency<br />
                                        </p>
                                    </div>
                                </div>
                                <div className="info">
                                    <div className="title">
                                        Heat recovery dry machine
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · Energy saving<br />
                                                    · Lower steam consumption<br />
                                                    · Lower electricity
                                                    consumption<br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h4>Dry PROCESS</h4>
                        <div className="item-list">
                            <div className="item item-5">
                                <div className="info">
                                    <div className="title">
                                        Robot arm PP spray
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · High productivity and
                                                    efficiency<br />
                                                    · Reducing chemical<br />
                                                    · Less energy consumption<br />
                                                    · Health friendly production
                                                    with water curtains and
                                                    compatibility to high power
                                                    air suction system
                                                </p>
                                    </div>
                                    <div className="arrow">
                                        <i className='arrow-right'></i>
                                    </div>
                                </div>
                                <div className="img">
                                    <img
                                        src="/imgs/aboutTCE_Production_20.png"
                                        alt="Micro Bubble Washing machine"
                                    />
                                </div>
                            </div>

                            <div className="item item-6">
                                <div className="img">
                                    <img
                                        src="/imgs/aboutTCE_Production_21.png"
                                        alt="Front loading less water washing machine"
                                    />
                                </div>
                                <div className="info">
                                    <div className="title">
                                        Laser washing machine
                                            </div>
                                    <div className="desc">
                                        <p>
                                            · Ensuring energy
                                                    efficiency<br />
                                                    · Friendly to the
                                                    environment and people<br />
                                                    · Less water, energy and
                                                    time<br />
                                                    · No hazardous,
                                                    environmentally friendly and
                                                    requires no chemical<br />
                                                    · Accuracy, good quality and
                                                    production are high<br />
                                        </p>
                                    </div>
                                    <div className="arrow">
                                        <i className='arrow-left'></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='control'>
                        <a className='btn btn-more'
                            href='https://youtu.be/YxOVZ1uvcvM' 
                            rel="noopener noreferrer"
                            target="_blank">
                            VIEW VIDEO
                        </a>
                    </div>
                </section>
            </div>
            <FooterLayoutComponent
                {...props} />
        </main>
    )
}

export default ProductionComponent;